import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EnvironmentProviders, Injectable } from '@angular/core';
import { BehaviorSubject, of, timeout } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/internal/operators/map';
import { environment } from 'src/environments/environment';
import { SessionService } from 'src/app/shared/services/sessionStorage.service';

@Injectable({
  providedIn: 'root'
})
export class RestClientService {
  user: any;
  private baseUrl = environment.apiUrl;

  constructor( private httpClient:  HttpClient,
    private localStorage: SessionService,
  ) {
    this.user = sessionStorage.getItem('currentUser') || '{}';
 
    
   }


    put<T>(api: string, endpoint: string, body: any) {
       const apiUrl = environment.apiUrl; //recupere l'url de l'api correspondante
       return this.httpClient
         .put<T>(apiUrl + endpoint, body)
         .pipe(this.responseHasErrorOperator(), timeout(1000 * 60 * 3));
     }


      get<T>(api: string, endpoint: string, params?: any, options?: any) {
         const apiUrl = environment.apiUrl; //recupere l'url de l'api correspondante
         return this.httpClient
           .get<T>(apiUrl + endpoint, { params })
           .pipe(this.responseHasErrorOperator(), timeout(1000 * 60 * 3));
       }
       post(
        endpoint: string, 
        body: any,
        options?: any
      ): Observable<any> {
        // console.log('environment.apiUrl:', environment.apiUrl);
        // console.log('endpoint:', endpoint);
        
        const fullUrl = `${environment.apiUrl}${endpoint}`;
        // console.log('Constructed URL:', fullUrl);
        
        // console.log('URL complète:', fullUrl);
    
        let headers = new HttpHeaders();
        headers = headers.set('Authorization', `Bearer ${this.user.token}`);
    
        return this.httpClient
          .post(fullUrl, body, { 
            headers: headers 
          })
          .pipe(timeout(1000 * 60 * 3));
      }
    

       
      responseHasErrorOperator() {
         return (observable: Observable<any>) =>
           observable.pipe(
             map((response) => {
               if (response.hasError) {
                 throw response.status.message;
               }
               return response;
             })
           );
       }

      
      
}
